import React from 'react';
import { IStyledComponent } from '@/context/AppContext';
import * as styles from './ArticleTemplate.scss';

const StyledArticleTemplate = (props: IStyledComponent) => <>{props.children({ styles })}</>;

export default StyledArticleTemplate;
